import {reporter} from 'common/report/error-reporting';

import type {Toast} from './';

export const DEFAULT_TOAST_TTL = 7000;

type Listener = () => void;

class ToastStore {
  private toasts: readonly Toast[] = [];
  private listeners = new Set<Listener>();
  private nextId = 1;

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };

  getSnapshot = (): readonly Toast[] => this.toasts;

  add(toast: Toast): Toast {
    const newToast: Toast = {
      id: this.nextId++,
      timeout: DEFAULT_TOAST_TTL,
      ...toast,
    };
    this.toasts = [...this.toasts, newToast];
    this.notify();
    return newToast;
  }

  close(toast: Toast): void {
    if (!toast) {
      reporter.warn(`Calling close with null param`);
      return;
    }
    this.toasts = this.toasts.map((t) => (t.id === toast.id ? {...t, hide: true} : t));
    this.notify();
  }

  clearAll(): void {
    this.toasts = this.toasts.filter((t) => t.persistent);
    this.notify();
  }

  // Test-only: wipe all toasts for story isolation. nextId stays monotonic so
  // stale toast references from a prior story can't collide with new ids.
  reset(): void {
    this.toasts = [];
    this.notify();
  }

  private notify(): void {
    this.listeners.forEach((l) => l());
  }
}

export const toastStore = new ToastStore();
